import React from "react";
import "./error.sass";

export default function Error({ mensaje, error, componenteActual }) {
  return (
    <div className={"container-error-" + componenteActual}>
      <div className="error-interno">
        <div className="imgNotificacion"></div>
        <h4>{error}</h4>
        <p>{mensaje}</p>
      </div>
    </div>
  );
}
